const dataCheckQuestion = {
  "Has the patient been on Cilostazol (Pletal) therapy for at least 12 weeks?": "Cilostazol Therapy",
  "Has the patient been on antiplatelet therapy for at least 12 weeks?": "Antiplatelet Therapy",
  "Has the patient been on statin therapy for at least 12 weeks?": "Statin Therapy",
  "Has the patient been on ACE inhibitor or Angiotensin Receptor Blocker?": "ACE Inhibitor or Angiotensin Receptor Blocker Therapy",
};

export default dataCheckQuestion;
